import React from 'react'
import { Redirect } from 'react-router-dom'
import jwt_decode from "jwt-decode";
export class ProtectedRouteKeyHelp extends React.Component {

    render() {
        const Component = this.props.component;
        let keyValueSegnalazioni = sessionStorage.getItem('Imp_help_desk');
        var bol = false;
        if(keyValueSegnalazioni != null)
            bol = JSON.parse(keyValueSegnalazioni) === "1" ? true : false;  
        const isAuthenticated = bol;
        return isAuthenticated ? (
            <Component />
        ) : (
            <Redirect to={{ pathname: '/home' }} />
        );
    }
}




export class ProtectedRouteKeyMappatura extends React.Component {

    render() {
        const Component = this.props.component;
        let keyValueSegnalazioni = sessionStorage.getItem('Imp_mappatura');
        var bol = false;
        if(keyValueSegnalazioni != null)
        bol = JSON.parse(keyValueSegnalazioni) === "1" ? true : false;  

        var user = JSON.parse(sessionStorage.getItem("user"));
        var bolUser = false;
        var decoded = jwt_decode(user.token);
        bolUser = decoded.RUOLO == 4?true:false;  

        const isAuthenticated = bol; 
        return isAuthenticated && bolUser? (
            <Component />
            ) : (
                <Redirect to={{ pathname: '/home' }} />
                );
            }
        }
        
     